import { createSelector } from '@ngrx/store';
import { TRAVEL_HOTEL_SUPPLIERS } from 'app.config';
import * as fromReducers from '../reducers';
import * as fromHotelSuppliers from '../reducers/hotel-suppliers.reducers';

export const getHotelSuppliersFeatureState = createSelector(
  fromReducers.getTravelSearchState,
  (state: fromReducers.TravelSearchState) =>
    state.hotelSuppliers || JSON.parse(localStorage.getItem(TRAVEL_HOTEL_SUPPLIERS))
);

export const getHotelSuppliers = createSelector(getHotelSuppliersFeatureState, fromHotelSuppliers.getHotelSuppliers);
